import React from 'react';
import cn from 'classname';
import _find from 'lodash/find';
import _get from 'lodash/get';
import EditSingleMatrixValueForm from '../forms/edit-single-matrix-value/main';

function Row(props) {
	const {
		row, columns, rows, intl, submitCell, offerSaleModelsMapping, changeHighlightedCountryId, highlightedCountryId
	} = props;
	const { main_niche, main_sale_model } = row;

	return (
		<tr className={cn({
			'checked_good_row': row.is_checked_good,
			'checked_bad_row': row.is_checked_good === false
		})}>
			<td className="fixed-col">{main_niche}({offerSaleModelsMapping[main_sale_model]})</td>
			{columns.map((col, index) => (
				<td
					key={index}
					className={cn({
						'position-relative default-cell hover-pointer': true,
						'hovered-col': highlightedCountryId === col.id,
						'is_new_country': col.is_new_country
					})}
					onMouseEnter={changeHighlightedCountryId.bind(null, col.id)}
					onMouseLeave={changeHighlightedCountryId.bind(null, null)}
				>
					{Number(_get(
						_find(	rows, {main_niche, main_sale_model, main_country_id: col.id}),
						'amount',
						null
					)) || ''}
					{Number(_get(
						_find(	rows, {main_niche, main_sale_model, main_country_id: col.id}),
						'max_amount',
						null
					)) ? ` - ` : ''}
					{Number(_get(
						_find(	rows, {main_niche, main_sale_model, main_country_id: col.id}),
						'max_amount',
						null
					)) || ''}
					<EditSingleMatrixValueForm
						form={`pm-cell-edit-${index}-${main_niche}-${main_sale_model}`} intl={intl} submitCell={submitCell}
						country_id={col.id}  main_niche={main_niche} main_sale_model={main_sale_model}
					/>
				</td>
			))}
		</tr>
	);
}

export default Row;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-payout-matrix/row.js